import "../../styles/strategiesInfo.css";

export default function StrategiesInfo({ onClose }) {
  return (
    <div className="info-backdrop" onClick={onClose}>
      <div className="info-modal" onClick={e => e.stopPropagation()}>

        <button className="info-close" onClick={onClose}>✕</button>

        <h2>Stratégiák működése</h2>
        <hr />

        <p className="info-lead">
          A stratégiák célja, hogy rendszerezd a fogadási gondolkodásodat,
          és elkülönítve tudd elemezni a különböző megközelítéseid eredményességét.
        </p>

        <ul className="info-list">
          <li>
            🧠 <strong>Stratégia létrehozása</strong> – Adj nevet a stratégiádnak,
            és határozd meg, milyen elvek alapján választod ki a tippeket
            (pl. liga, piac, odds tartomány).
          </li>
          <li>
            🗂️ <strong>Külön kezelhető megközelítések</strong> – Minden stratégia
            önálló egységként működik, így pontosan láthatod,
            melyik hoz hosszú távon eredményt.
          </li>
          <li>
            📈 <strong>Tudatos használat</strong> – A tippeket mindig a megfelelő
            stratégiához rögzítsd, hogy az adatok ne keveredjenek.
          </li>
        </ul>

        <p className="info-footnote">
          🎟️ <strong>Szelvénykészítés röviden:</strong>
          A rögzített stratégiákra építve később szelvényeket hozhatsz létre,
          ahol a tippek már strukturált rendszerből érkeznek,
          nem véletlenszerű döntésekből.
        </p>



      </div>
    </div>
  );
}
